import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { dbnpRegistries } from "../../../../../../redux/dbnp-registries/action";
import { selectDbnpRegistriesListItems } from "../../../../../../redux/dbnp-registries/selector";
import * as R from "ramda"
import storePersist from "../../../../../../redux/storePersist";
const DbnpRegistries = () => {
    const dispatch = useAppDispatch()
    const librariesItems = storePersist?.get("library")?.current;
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const dbnpregistriesItems = useSelector(selectDbnpRegistriesListItems)
    const [columnDefs, setColumnDefs] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'DBNIEName', headerName: 'DBNIE Name'},
            { field: 'DBNPName', headerName: 'DBNP Name'},
            { field: 'name_of_authorised_signatory', headerName: 'Name Of Authorised Signatory', searchField: 'name_of_authorised_signatory', sortable: true, filter: true, filterType: 'text' },
            { field: 'address_of_authorisedSignatory', headerName: 'Address Of AuthorisedSignatory' },
            {
                field: 'ops_no', headerName: 'ops Number',valueFormatter: getOpsName 
            },
            { field: 'email_id', headerName: 'Email', searchField: 'email_id', sortable: true, filter: true, filterType: 'text' },
            { field: 'mobile_no', headerName: 'Mobile No' },
            { field: 'country', headerName: 'country' },
            { field: 'subscriber_id', headerName: 'Subscriber' },
            { field: 'unique_key_id', headerName: 'Unique Key' },
            { field: 'IsProxyNetwork', headerName: 'IsProxyNetwork',cellRenderer: 'yesNoRenderer' },
            
        ]);
    }
    const getOpsName = (storeNameId: any) => {
        const StoreNameList = R.find(
          (storeName: any) => parseInt(
            storeName.Value,
            10
          ) === parseInt(
            storeNameId,
            10
          ),
          librariesItems?.Ops_no
        )
        return StoreNameList ? StoreNameList.Description : ''
      }
    const handleAdd = () => {
        navigate(`${0}`)
    }

    const handleEdit = (data: any) => {

        navigate(`${data?.Id}`)
    }

    const handleDelete = (data: any) => {
        dispatch(dbnpRegistries.delete({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries/delete`,
            entity: 'dbnpRegistries',
            jsonData: {
                Records: [
                    {
                        Id: data?.Id
                    }
                ]
            }
        })).then(() => {
            dispatch(dbnpRegistries.list({
                url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries/list`,
                entity: 'dbnpRegistries',
                jsonData: {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "Id",
                    "SortOrder": "desc",
                }
            }))
        });
    }
    const fetchDbnpRegistries = () => {

        dispatch(dbnpRegistries.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries/list`,
            entity: 'dbnpRegistries',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
            }
        }))

    }

    useEffect(() => {
        createColumnDefs()
        fetchDbnpRegistries()
    }, [pageData, pageSize])

    const additionButtons: any = [
        // {
        //     svg:
        //       <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
        //         <title>Add DBNP Registry</title>
        //         <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        //       </svg>,
        //     // name: 'Add DBNP Registry',
        //     callback: () => handleAdd(),
        // },
        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            // name: 'Reload',
            callback: () => handleReloadData(),
        }
    ];

    const handleReloadData = () => {
        fetchDbnpRegistries();
    }

    const handleSearch = (data: any) => {
        console.log('Search data', data)
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "Name",
                FieldText: "Name",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        dispatch(dbnpRegistries.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbnp-registries/list`,
            entity: 'dbnpRegistries',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
            }
        }));
    }

    const handleSelect = (item: any, checked: any) => {
        console.log("Item", checked, item)
    }

    const handleSelectAll = (items: any[], checked: any) => {
        console.log("Items count", checked, items?.length)
        console.log('items', items)
    }

    return (
        <>
            {dbnpregistriesItems?.isLoading ? <PageLoader /> :
                <Table columnData={columnDefs} rowData={dbnpregistriesItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
                    enableFilter={true} onSearch={handleSearch} onSelect={handleSelect} onSelectAll={handleSelectAll}
                    paginationData={dbnpregistriesItems?.result?.pagination} onEdit={handleEdit}
                    additionButtons={additionButtons} headingName="DBNP Registries" />
            }
        </>
    );
};

export default DbnpRegistries;


